import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export const TOKEN_KEY = "thirteenav_token";

api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function mediaUrl(path) {
    if (!path) return "";
    return path.startsWith("http") ? path : `${BACKEND_URL}${path}`;
}

export function fileUrl(fileId) {
    const token = localStorage.getItem(TOKEN_KEY);
    return `${API}/files/${fileId}${token ? `?auth=${token}` : ""}`;
}

export default api;
